// extracted by mini-css-extract-plugin
module.exports = {"contentToggle":"promo-code-module__contentToggle___qTtl5","content":"promo-code-module__content___x2jay","applyBtn":"promo-code-module__applyBtn___u83lZ"};